// M4-A5.2 — iOS Universal Links + custom scheme (SOLO runtime Capacitor).
// Additivo e conservativo: web (tricomas.it in browser) totalmente invariato.
// Sicurezza: accetta SOLO host tricomas.it (https) e lo schema masstudio:// verso route
// interne whitelisted; nessun open redirect, nessuno scheme arbitrario, fallback sicuro.
let _registered = false;

const ALLOWED_HOSTS = ["tricomas.it", "www.tricomas.it"];
const NATIVE_SCHEME = "masstudio:";
// Radici interne ammesse dal ritorno post-checkout / deep link.
const ALLOWED_ROOTS = ["payment", "profilo", "prenota"];

// Restituisce un path interno relativo sicuro oppure null.
// Gestisce SIA https://tricomas.it/payment/success?...  SIA  masstudio://payment/success?...
// (nel custom scheme JS mette "payment" in hostname e "/success" in pathname).
export function deepLinkToInternalPath(rawUrl) {
  let u;
  try {
    u = new URL(rawUrl);
  } catch (e) {
    return null;
  }

  let path;
  if (u.protocol === NATIVE_SCHEME) {
    // masstudio://payment/success?x -> hostname="payment", pathname="/success"
    const host = (u.hostname || "").replace(/^\/+/, "");
    if (!ALLOWED_ROOTS.includes(host)) return null;
    path = `/${host}${u.pathname || ""}${u.search || ""}${u.hash || ""}`.replace(/\/{2,}/g, "/");
  } else if (u.protocol === "https:" || u.protocol === "http:") {
    const host = (u.hostname || "").toLowerCase();
    if (!ALLOWED_HOSTS.includes(host)) return null; // host non autorizzato -> ignorato
    const firstSeg = (u.pathname || "/").split("/").filter(Boolean)[0] || "";
    if (!ALLOWED_ROOTS.includes(firstSeg)) return null;
    path = `${u.pathname || "/"}${u.search || ""}${u.hash || ""}`;
  } else {
    return null; // schema non ammesso
  }

  if (!path.startsWith("/")) return null;
  // Anti-loop: rimuovi l'eventuale marker native dalla URL interna finale.
  path = path.replace(/([?&])native=1(&|$)/, (m, p1, p2) => (p2 === "&" ? p1 : "")).replace(/[?&]$/, "");
  return path;
}

async function closeBrowserSafe() {
  try {
    const { Browser } = await import("@capacitor/browser");
    await Browser.close();
  } catch (e) {
    /* browser già chiuso / plugin assente: non bloccante */
  }
}

export async function initMobileDeepLinks() {
  const Cap = window.Capacitor;
  if (!Cap || typeof Cap.isNativePlatform !== "function" || !Cap.isNativePlatform()) return;
  if (_registered) return; // nessun doppio listener
  _registered = true;
  try {
    const { App } = await import("@capacitor/app");
    App.addListener("appUrlOpen", async (event) => {
      const path = deepLinkToInternalPath(event && event.url);
      if (!path) return; // fallback sicuro: ignora URL non validi/host non ammessi
      // Ritorno dal checkout nativo: chiudi il browser di sistema (SFSafariViewController).
      await closeBrowserSafe();
      try {
        window.history.pushState({}, "", path);
        window.dispatchEvent(new PopStateEvent("popstate"));
      } catch (e) {
        try { window.location.assign(path); } catch (_) { /* noop */ }
      }
    });
  } catch (e) {
    /* plugin @capacitor/app non disponibile: non bloccante */
  }
}
